module.exports = __webpack_public_path__ + "static/media/clear_n.3161cd8e.svg";